import * as T from '../constants/types';
import { Auth } from 'aws-amplify';
import { throwError } from './throwNotification';

export const onSignOut = () => async dispatch => {
    try {
        await Auth.signOut();
        dispatch({ type: T.SIGN_OUT + T.SUCCESS });
        window.location.href = '/';
    } catch (error) {
        dispatch(throwError(error, T.SIGN_OUT + T.ERROR));
    }
};
